export default function WhatsAppChatBtn() {
	return (
		<a id="whatsapp-chat" href="https://wa.me/+33627570132?text=Bonjour%20WebServices%20">
			<p>Comment puis-je vous aider ?</p>
			<span className="sr-only">Ouvrir whatsapp</span>
		</a>
	);
}